import React from 'react';
import { useTranslation } from 'react-i18next';
import { AgencyFilterHeaderContainer, chipsStyles } from './styled';
import { Chips } from '../../../ui/Chips';

interface AgencyFilterHeaderProps {
  categories: {
    title: string | null;
    __typename?: 'Category';
    id: string;
    pluralName: string;
  }[];
  activeCategoryId: string;
  onClickItem: (id: string, isSetLeasedCategories?: boolean) => void;
  categoriesContainerRef: React.RefObject<HTMLDivElement>;
}

export const AgencyFilterHeader: React.FC<AgencyFilterHeaderProps> = ({
  categories,
  onClickItem,
  activeCategoryId,
  categoriesContainerRef
}) => {
  const { t } = useTranslation();

  const allCategories = [
    {
      id: 'all',
      pluralName: t('pages.agency.all_categories')
    },
    ...categories
  ];

  return (
    <AgencyFilterHeaderContainer
      data-cy="agency-filter__header"
      ref={categoriesContainerRef}
    >
      {allCategories?.map(item => (
        <Chips
          id={`chip-${item.id}`}
          key={item.id}
          text={item?.pluralName}
          value={item.id}
          type="button"
          hasCustomOnChange
          storedValue={activeCategoryId}
          onClick={() => onClickItem(item.id)}
          styles={chipsStyles}
          cypress="agency-filter__header-item"
        />
      ))}
    </AgencyFilterHeaderContainer>
  );
};
